import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./cookieStyle.css";
import "aos/dist/aos.css";

export default function Footer() {
    const navigate = useNavigate();

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieConsent = localStorage.getItem("cookieConsent");
        if (!cookieConsent) {
            setIsVisible(true);
        }
    }, []);

    function switchSide(side) {
        navigate(side);
    }

    function setCookies(state) {
        setIsVisible(false);
        if (state === true) {
            localStorage.setItem('cookieConsent', 'accepted');
        } else {
            localStorage.setItem('cookieConsent', 'declined');
        }
    }

    if (!isVisible) return null;

    return (
        <div className="cookieContainer">
            <img src="/img/cookie.png" />
            <div>
                <h1>Cookie Einstellungen</h1>
                <h2>Mit unseren Cookies möchten wir Ihnen ein funktionsreiches Nutzen unserer Website bieten.
                    Dazu zählen zum Beispiel das speichern von Analysen und Merken von Einstellungen auf unserer
                    Seite. Wenn das für Sie in ordnung ist, stimmen Sie der Nutzung von Cookies für Präferenzen,
                    Statistiken und Marketing einfach durch einen Klick auf "Akzeptieren" zu.</h2>
                <div className="buttonContainer">
                    <button className="green" onClick={() => setCookies(true)}>Akzeptieren</button>
                    <button className="grey" onClick={() => setCookies(false)}>Ablehnen</button>
                </div>
            </div>
        </div>
    )
}
